<!--上传图片组件-->
<template>
  <div class="dg__upload">
    <el-upload ref="upload" action :http-request="uploadFiles" :limit="limit" :show-file-list="false"
      :accept="fileType">
      <div v-if="imgBtn">
        <slot></slot>
      </div>
      <el-button v-else style="color: #606266 !important;">
        <slot></slot>
      </el-button>
    </el-upload>
    <template v-if="urlList && urlList.length">
      <div v-for="(i, key) in urlList" :key="key">
        <a style="vertical-align: bottom" :href="i.value||i.path" class="aui-inline no-underline" target="_blank">
          <p class="inline url-box aui-ellipsis-1"><i class="el-icon-document mr-[4]"></i>{{ attrs.code == 'OTHER' ? i.name : `${fileName}${key + 1}` }}
          </p>
        </a>
        <i class="icon cursor-pointer pl-[6]" @click="hanldeDel(key)">&#xe641;</i>
      </div>
    </template>
    <div v-for="(v, index) in progress" :key="index" class="progress">
      <el-progress :percentage="v.progress"></el-progress>
    </div>
    <!-- <div>
      <a style="vertical-align: middle" :href="url" class="aui-inline" target="_blank">
        <p class="url-box aui-ellipsis-1 inline"><i class="icon">&#xe74f;</i>21312312312312321321</p>
      </a>
      <i class="icon cursor-pointer pl-[6]" @click="hanldeDel">&#xe641;</i>
    </div> -->

  </div>
  <!-- <el-upload ref="upload" action :http-request="uploadFiles" :limit="limit" multiple :show-file-list="false"
    :class="{ uploadImg1: isActive, uploadImg2: !isActive }" :accept="fileType">
    <slot></slot>
  </el-upload> -->
</template>

<script>
import mixin from "@/assets/js/mixin";
// import { uploadFile } from "@/api/personalCenter";
import { remove } from "@/assets/js/utils";
export default {
  mixins: [mixin],
  name: "dg-upload-list",
  props: {
    imgBtn: {
      type: Boolean,
      default: false,
    },

    fileName: {
      type: String,
      default: '文件',
    },
    objName: String,
    attrs: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: "",
    fileSize: {
      type: Number,
      default: 50,
    },
    fileType: {
      type: String,
      default: ""
    },
    unFileType: {
      type: String,
      default: ""
    },
    limit: {
      type: Number,
      default: 6
    },
    imgUrl: {
      type: Array,
      default: () => []
    },
    index: {
      type: Number,
      default: 1
    },
    // 选择上传图片的样式
    isActive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uploadUrl: '/customer/upload',
      urlList: [],
      progress:[],
    }
  },
  watch: {
    value: {
      handler(val) {
        this.urlList = val;
      },
      immediate: true
    },
  },
  mounted() {

  },
  methods: {
    hanldeDel(key) {
      this.$emit("hanldeDel", key, this.objName)
    },
    uploadFiles(file) {
      
      if (this.urlList.length >= this.index) {
        Mirror.emit('tips_bus', `文件最多可上传${this.index}份`);
        return ""
      }
      // 判断文件格式
      let fType = this.fileTypes(file.file.name)
      if (this.fileType.indexOf(fType) == -1) {

        Mirror.emit('tips_bus', `上传文件格式错误，仅支持后缀为${this.fileType}的文件`);
        this.$refs.upload.clearFiles()
        return ""
      }

      let unType = this.unFileTypes(file.file.name)
      if (this.unFileType.indexOf(unType) == 1) {
        Mirror.emit('tips_bus', `上传文件格式错误，不能上传后缀为${this.unFileType}的文件`);
        this.$refs.upload.clearFiles()
        return ""
      }

      if (file.file.size > (this.fileSize * 1024 * 1024)) {
        Mirror.emit('tips_bus', `上传文件过大，仅支持大小为${this.fileSize}M的文件`);
        this.$refs.upload.clearFiles()
        return ""
      }
      let   fileData = file.file
      this.$refs.upload.clearFiles()  // 清除历史历史记录
      let   form = new FormData()
      form.append('fileName', fileData)
      this.progress.push({
        progress: 0,
      });
      let index_progress = this.progress.length - 1;
     
      ajax.uploadFile({
        url: "/customer/upload",
        data: form,
        self: this,
        onUploadProgress: (progress) => {
          console.log(1)
          this.progress[index_progress].progress = progress;
        },
        success: res => {
          console.log(2)
          remove(this.progress, this.progress[index_progress]);
          if (res) {
            remove(this.progress, this.progress[index_progress]);
            Mirror.emit('tips_el_alert_box_close');
            let d = {...this.attrs, size: fileData.size, name: fileData.name};
            if (this.attrs && this.attrs["key"]) {
              d[this.attrs["key"]] = res;
            } else {
              d["path"] = res;
            }
            console.log(d);
            this.urlList.push(d)
            console.log(3)
            this.$emit("input", this.urlList, this.objName);
         
          }
        }
        ,
        fail: (err) => {
          remove(this.progress, this.progress[index_progress]);
          Mirror.emit('tips_bus', err.msg);
          // this.$message({ message: `图片上传失败`, type: "error" });
        }
      })
    },
    // 获取文件后缀
    fileTypes(name) {
      if (this.fileType == "" || this.fileType.indexOf("*") != -1) {
        return ""
      } else {
        let fType = name.split(".")[name.split('.').length - 1]
        return fType
      }
    },
    // 获取文件后缀
    unFileTypes(name) {
      if (this.unFileType == "") {
        return ""
      } else {
        let unType = name.split(".")[name.split('.').length - 1]
        return unType
      }
    }
  }
}
</script>

<style scoped lang="less">
.dg__upload {
  min-width: 120px;
  line-height: normal;

  .icon {
    font-size: 12px;
  }

  &.inline {
    display: inline-block;
    margin-right: 10px;
    vertical-align: top;
  }

  .file-input {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    z-index: 5;
    cursor: pointer;
    opacity: 0;
  }

  .preview {
    position: absolute;
    top: 1%;
    left: 1%;
    width: 98%;
    height: 98%;
    object-fit: cover;
    object-position: center;
    display: block;
    border-radius: 4px;
  }

  .url-box {
    // width: 200px;
    color: #606266 !important;
    font-size: 12px;
    padding-top: 5px;

    &.inline {
      // width: 170px;
    }
  }

  a:hover {
    text-decoration: underline;
    color: #c7c7c7;
  }
}
</style>
